import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const HomeInsuranceIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M14.5 26.2c-.4 0-.8-.3-.8-.8V12.7c0-.2.1-.4.3-.6L24.4 4c.1-.1.3-.2.5-.2s.3.1.5.2l10.4 8.4c.2.1.3.4.3.6v12.4c0 .4-.3.8-.8.8H14.5z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M24.9 4.7 35.3 13v12.4H14.5V12.7l10.4-8m0-1.5c-.3 0-.6.1-.9.3l-10.4 8.1c-.4.3-.6.7-.6 1.2v12.7c0 .8.7 1.5 1.5 1.5h20.8c.8 0 1.5-.7 1.5-1.5V13c0-.5-.2-.9-.6-1.2L25.9 3.5c-.3-.2-.6-.3-1-.3z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <path
        d="M37 15.3c-.2 0-.3-.1-.5-.2L24.9 5.5 13 15.1c-.1.1-.3.2-.5.2s-.4-.1-.6-.3l-1.2-1.4c-.1-.2-.2-.4-.2-.6s.1-.4.3-.5l13.7-11c.1-.1.3-.2.5-.2s.3.1.5.2l13.2 11c.2.1.2.3.3.5s0 .4-.2.5L37.6 15c-.2.2-.4.3-.6.3z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="m24.9 2.1 13.2 11-1.1 1.4-12.1-10-12.4 10-1.2-1.5L24.9 2.1m0-1.5c-.3 0-.7.1-.9.3l-13.6 11c-.6.5-.7 1.5-.2 2.1l1.2 1.4c.2.3.6.5 1 .6h.2c.3 0 .7-.1.9-.3L25 6.5l11 9.2c.3.2.6.3 1 .3s.9-.2 1.2-.5l1.2-1.4c.3-.3.4-.7.3-1.1 0-.4-.2-.8-.5-1L25.9 1c-.3-.3-.6-.4-1-.4z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <path
        d="m19.3 5.3-3.4 2.9V2.4h3.4z"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        d="M28.5 25.4H21v-7.9c0-1.1.9-2 2-2h3.5c1.1 0 2 .9 2 2v7.9z"
        fill="#E81C30"
        className={styles.accentColor}
      />
      <path
        d="M1.9 36.2s4.6-4.6 9.1-3.6c4.6.9 7.3 1.8 10.9 1.8h6.4s4.6.9 5.5.9 2.7 0 4.6-.9c1.8-.9 3.6-3.6 5.5-3.6 1.8 0 4.6.9 3.6 3.6-.9 2.7-7.3 8.2-7.3 8.2s-3.6 4.6-8.2 4.6H10.1l-8.2-11z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="m37.5 45.3 9.4-9.4c.6-.6.9-1.4.9-2.3 0-.9-.3-1.7-.9-2.3-1.3-1.3-3.3-1.3-4.6 0l-6 6c0 1.8-1.5 3.3-3.4 3.3h-8.6s-.1 0-.1-.1c0 0 0-.1.1-.1h8.6c1.8 0 3.3-1.5 3.3-3.3 0 0 0 0 0 0 0-1.8-1.5-3.3-3.3-3.3H19.4s0 0 0 0c-1.8-.9-3.5-1.5-6.3-1.5-5 0-9.4 3.6-11.3 5.5l7.3 9.1 7.1.1h16.5c1.9.3 3.6-.4 4.8-1.7l9.4-9.3c.6-.6 1-1.5 1-2.4 0-.9-.3-1.7-1-2.4-1.3-1.3-3.4-1.3-4.8 0l-6 6c-.1-1.8-1.5-3.2-3.4-3.2H19.5c-1.8-.9-3.6-1.5-6.3-1.5-5.1 0-9.1 3.2-11 5.1v.1"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M11 47.2c0 1-.8 1.8-1.8 1.8H3.7c-1 0-1.8-.8-1.8-1.8V32.6c0-1 .8-1.8 1.8-1.8h5.5c1 0 1.8.8 1.8 1.8M10.5 33.1v15.5"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </Icon>
  )
}
